/**
 * Upload/Download area layout (Figma node 5238-101614).
 * Design tokens: drag-drop content, URL input, Get Started button.
 */

export const UPLOAD_AREA_LAYOUT = {
  /** Total width of the input + button row (design: drag-drop-content-width) */
  contentWidth: 672.563,
  /** URL input width px */
  urlInputWidth: 570,
  /** URL input and button height px */
  urlInputHeight: 45,
  /** Project title input height px */
  projectTitleInputHeight: 40,
  /** Gap between URL input and Get Started button px */
  inputButtonGap: 12,
  /** Pill shape for input and button */
  radiusPill: 100,
} as const;
